import {
  AmountTitle,
  AmountColumn,
  ButtonSection,
  ButtonsWrapperBizum,
  ButtonsWrapperPayment,
  PaymentOverlay,
  PaymentSection,
  PaymentView,
  PaymentWrapper,
  PaymentHeader,
  MoneyWrapper,
  PaymentInformation,
  PaymentInformationRow,
  TitleSection,
  InfoCardPaymentPlan,
  PaymentPlanTextMedium,
  PaymentPlanTextBold,
} from './PaymentStyledComponents';
import { TextBold, TextRegular } from '../../styles/GlobalStyledComponents';
import { useEffect, useRef, useState } from 'react';
import {
  PaymentMethod,
  PaymentMethodOrder,
} from '../../interfaces/PaymentMethod';
import { useNavigate } from 'react-router';
import { ROUTES_PATH } from '../../constants';
import { PaymentTypes } from './../../components/CardInputs/PaymentTypes/PaymentTypes';
import {
  CardLabel,
  CardsList,
  InfoCardMiniSpan,
  PaymentSelectText,
} from '../../components/CardInputs/CardsStyledComponents';
import Button from '../../components/Button/Button';
import { colors } from '../../styles/Colors';
import { theme } from '../../styles/Theme';
import { PaymentModal } from '../../components/PaymentModal';
import { useDebtResult } from '../../contexts/DebtContext';
import { usePaymentSelected } from '../../contexts/PaymentSelectedContext';
import {
  DebtResponse,
  LoanData,
  TransactionReasonEnum,
  TransactionReasonTexts,
} from '../../interfaces/Debt';
import { PaymentCard, PaymentMethods } from '../../interfaces/Loan';
import FinancialService from '../../services/Financial';
import { useLocation } from 'react-router-dom';
import { PayButtonWrapper } from '../../components/Button/ButtonStyledComponent';
import {
  calculateTotalExcusedAmount,
  getDebtAmount,
  handlePaymentTypesOrder,
  newPendingPayment,
  pricesHelper,
  removePaymentMethodError,
  savePaymentMethodError,
} from '../../utils/paymentsHelper';
import {
  PaymentDataRequest,
  PaymentDataResponse,
  ReusePaymentOptionalParams,
  ReusePaymentRequest,
} from '../../interfaces/Payment';
import { Transition } from '../Transition';
import { useUserResult } from '../../contexts/UserContext';

import { InsightService } from '@pepper/insights-react';
import { useCardsResult } from '../../contexts/CardsContext';

import { PaymentHandle } from '@pepper/google-apple-pay-react';
import { PaymentTypesEnum } from '@pepper/google-apple-pay-react/dist/cjs/interfaces/Payment';
import TokenService from '../../services/Token';
import { TransactionReasonEnum as PaymentTransactionReasonEnum } from '@pepper/google-apple-pay-react/dist/cjs/interfaces/Payment';
import {
  ContainerBackgroundMenu,
} from '../../components/CustomerHeader/CustomerHeaderStyledComponents';
import GAnalyticsService from '../../services/GAnalytics/ganalytics.service';
import { Bizum } from '@pepper/bizum-react';
import dayjs from 'dayjs';
import { GTMFlowSteps } from '../../interfaces/GTM';
import IconMoney from '../../assets/icons/IconMoney';
import { ViewMode } from '../../interfaces/Mode';
import { PaymentPlanParams } from '../../interfaces/PaymentPlan';
import { loadFromSessionStorage } from '../../utils/sessionStorageHelper';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';

const Payment = () => {
  const navigate = useNavigate();
  const search = useLocation().search;

  const { userResult } = useUserResult();
  const { debtResult } = useDebtResult();
  const {
    paymentSelected,
    deletePaymentSelected,
    coPaymentSelected,
    deleteCoPaymentSelected,
  } = usePaymentSelected();
  const { cardsResult } = useCardsResult();

  const paymentMethod = new URLSearchParams(search).get('payment_method');
  const paymentPlanData = loadFromSessionStorage(
    'pepper-payment-plan-data',
  ) as PaymentPlanParams | null;
  let userId = userResult?.document_id;

  const embedded =
    sessionStorage.getItem('pepper-view-mode') === ViewMode.IFRAME;
  const appViewMode =
    sessionStorage.getItem('pepper-view-mode') === ViewMode.APP;
  const flowCO = sessionStorage.getItem('flow') === 'co';

  let advanceFee = JSON.parse(sessionStorage.getItem('advance-fee') || 'false');
  const advanceFeeOK = sessionStorage.getItem('advance-fee-OK') === 'true';
  let paymentMethodError = sessionStorage.getItem(
    'pepper-payment-method-error',
  );
  const sofortPaymentKo =
    localStorage.getItem('sofortPayment') === 'CANCEL' || false;

  const [initTime, setInitTime] = useState<dayjs.Dayjs>(dayjs());

  const [methodSelected, setMethodSelected] = useState<
    PaymentMethod | string | null
  >(paymentMethod);
  const { red4, white } = colors;
  const { textBold } = theme.fontWeight;
  const [modalOpened, setmodalOpened] = useState<boolean>(false);
  const [currentLoan, setCurrentLoan] = useState<LoanData>();
  const [cardList, setCardList] = useState<PaymentCard[]>([]);
  const [selectedCard, setSelectedCard] = useState<PaymentCard>();
  const [loading, setLoading] = useState(false);
  const [showCardsError, setShowCardsError] = useState(false);
  const [isOneQuotaDebt, setIsOneQuotaDebt] = useState(false);
  const [isAppleAvailable, setIsAppleAvailable] = useState(false);
  const [isGoogleAvailable, setIsGoogleAvailable] = useState(false);
  const [paymentBizum, setPaymentBizum] = useState<PaymentDataResponse>();
  const [resetBizum, setResetBizum] = useState(false);
  // Evita que un mismo error de Bizum dispare handleBizumError dos veces:
  // la librería @pepper/bizum-react llama a error() tanto desde el mensaje
  // MC2P_CANCEL como desde el interval que vigila el cierre de la ventana.
  const bizumErrorHandledRef = useRef(false);
  const [loadingBizum, setLoadingBizum] = useState(false);
  const [coTotalAmount, setCoTotalAmount] = useState<number>(0);
  const [amountExcused, setAmountExcused] = useState<number>(0);
  const defaultRetryOrder: PaymentMethodOrder = {
    express: 1,
    credit_card: 2,
    bizum: 3,
    bank_account: 4,
    apple: 5,
    google: 6,
    others: 7,
  };

  const [retryOrder, setRetryOrder] = useState<PaymentMethodOrder | null>(
    defaultRetryOrder,
  );
  const [creatingPaymentPlan, setCreatingPaymentPlan] = useState(
    paymentPlanData ? true : false,
  );

  const handleAppBizumPayment = () => {
    if (showCardsError) {
      removePaymentMethodError();
      setShowCardsError(false);
    }
    window.parent.postMessage(
      { action: 'BIZUM_PAYMENT_START', data: appViewMode },
      '*',
    );
  };

  const handleBizumError = () => {
    if (bizumErrorHandledRef.current) return;
    bizumErrorHandledRef.current = true;
    setMethodSelected(null);
    changePaymentError(PaymentMethod.BIZUM);
    setResetBizum(true);
    GAnalyticsService.sendKoEvent(GTMFlowSteps.TYPES_PAYMENTS);
  };

  const handleSuccessEnd = () => {
    InsightService.logTrace('BizumSuccess', [
      { paymentMethodSelected: PaymentMethod.BIZUM },
      { loanId: paymentBizum?.loan_id },
      { success: true },
    ]);
    if (paymentBizum) {
      GAnalyticsService.sendContinuePayment(
        initTime,
        GTMFlowSteps.TYPES_PAYMENTS,
        {
          payment_method: PaymentMethod.BIZUM,
          payment_transaction_reason: paymentBizum.transaction_type,
          payment_iin_number: '',
          payment_card_brand: '',
          payment_third_used: paymentBizum.third_party,
        },
      );
      GAnalyticsService.sendPurchase({
        currency: 'EUR',
        transaction_id: paymentBizum.loan_id,
        value: paymentBizum.amount,
        items: [
          {
            itemId: `payment-${paymentBizum.payment_method_id}`,
            itemName: 'Payment-Landing',
          },
        ],
      });
      savePaymentMethodAnalytics();
      // Se guarda el pago realizado en el local storage
      newPendingPayment(paymentBizum);
    }
    if (advanceFee) {
      sessionStorage.setItem('advance-fee-OK', 'true');
    }
    navigate(ROUTES_PATH.SUCCESS);
  };

  const createPayment = async () => {
    bizumErrorHandledRef.current = false;
    setLoadingBizum(true);
    if (methodSelected && (paymentSelected || coPaymentSelected) && userId) {
      try {
        const data: PaymentDataRequest = {
          url_ok: `${process.env.REACT_APP_URL}/payment-check/?payment=OK`,
          url_ko: `${process.env.REACT_APP_URL}/payment-check/?payment=KO`,
          url_cancel: `${process.env.REACT_APP_URL}/payment-check/?payment=CANCEL`,
          payment_method: methodSelected,
          transaction_reason:
            paymentSelected?.transaction_reason ??
            coPaymentSelected?.transaction_reason ??
            TransactionReasonEnum.DEC,
          transaction_type:
            methodSelected === PaymentMethod.CREDIT_CARD
              ? 'VERIFY'
              : 'PURCHASE',
          document_id: userId,
          // amount: paymentSelected?.amount,
          loan_id: paymentSelected?.loan_id ?? coPaymentSelected?.loan_id ?? '',
        };
        if (paymentSelected && methodSelected !== PaymentMethod.CREDIT_CARD) {
          data.amount = parseFloat(paymentSelected?.amount.toFixed(2));
        }
        if (flowCO && coPaymentSelected && coPaymentSelected.certified_debt) {
          data.loan_id = coPaymentSelected.loan_id;
          data.amount = parseFloat(coPaymentSelected.certified_debt.toFixed(2));
          data.transaction_reason =
            coPaymentSelected.transaction_reason ?? TransactionReasonEnum.DEC;
        }
        if (
          flowCO &&
          ((coPaymentSelected &&
            coPaymentSelected.transaction_reason ===
              TransactionReasonEnum.CPP) ||
            (paymentSelected &&
              paymentSelected.transaction_reason === TransactionReasonEnum.CPP))
        ) {
          if (!loadFromSessionStorage('pepper-payment-plan')) {
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            return;
          }
        }
        const paymentData = await FinancialService.createPayment(data);
        if (paymentData) {
          setPaymentBizum(paymentData);
          if (appViewMode) {
            window.parent.postMessage(
              {
                action: 'BIZUM_PAYMENT_DATA',
                paymentData,
                initTime,
                advanceFee,
              },
              '*',
            );
          }
          GAnalyticsService.savePaymentsDataLayer({
            payment_id: paymentData.payment_id,
            transaction_reason: data.transaction_reason,
            transaction_type: paymentData.transaction_type,
            third_party: paymentData.third_party,
            status: paymentData.status,
            amount: data?.amount ? data.amount.toString() : '0',
            amount_excused: amountExcused.toString(),
          });
          InsightService.logTrace('PaymentSelected', [
            { PaymentMethod: methodSelected },
            { amount: paymentData.amount.toString() },
            {
              amountExcused:
                data.transaction_reason !== TransactionReasonEnum.DEC
                  ? amountExcused?.toString()
                  : 0,
            },
            { loan_id: paymentData.loan_id },
            { transaction_reason: data.transaction_reason },
            { type: paymentData.transaction_type },
            { route: ROUTES_PATH.TYPES_PAYMENTS },
          ]);
        }

        paymentData.self_url = paymentData.self_url.replace(
          'redirect=true',
          'redirect=false',
        );
      } catch (error) {
        setShowCardsError(true);
      } finally {
        setLoadingBizum(false);
      }
    } else {
      setLoadingBizum(false);
    }
  };

  const savePaymentMethodAnalytics = () => {
    GAnalyticsService.sendContinuePaymentMethod(initTime);
  };

  const openPayment = () => {
    if (
      paymentSelected?.transaction_reason === TransactionReasonEnum.POP ||
      paymentSelected?.transaction_reason === TransactionReasonEnum.DEC ||
      paymentSelected?.transaction_reason === TransactionReasonEnum.DEP ||
      paymentSelected?.transaction_reason === TransactionReasonEnum.PAN ||
      (flowCO && coPaymentSelected)
    ) {
      sessionStorage.setItem('able-to-advance-fee', 'false');
    } else {
      sessionStorage.setItem('able-to-advance-fee', 'true');
    }

    if (showCardsError) {
      removePaymentMethodError();
      setShowCardsError(false);
    }

    if (coPaymentSelected && coPaymentSelected.certified_debt) {
      InsightService.logTrace('CoPaymentSelected', [
        { PaymentMethod: methodSelected },
        { amount: coPaymentSelected.certified_debt.toString() },
        { loan_id: coPaymentSelected?.loan_id },
        { transaction_reason: coPaymentSelected?.transaction_reason },
        { type: coPaymentSelected?.product_type },
      ]);
    } else {
      InsightService.logTrace('PaymentSelected', [
        { PaymentMethod: methodSelected },
        { amount: paymentSelected?.amount.toString() },
        { loan_id: paymentSelected?.loan_id },
        { transaction_reason: paymentSelected?.transaction_reason },
        { type: paymentSelected?.type },
      ]);
    }
    savePaymentMethodAnalytics();
    if (
      methodSelected === PaymentMethod.CREDIT_CARD ||
      methodSelected === PaymentMethod.BIZUM ||
      methodSelected === PaymentMethod.BANK_ACCOUNT
    ) {
      navigate(ROUTES_PATH.TPV + `?payment_method=${methodSelected}`);
    } else if (methodSelected === PaymentMethod.EXPRESS) {
      handlePaymentClick();
    }
  };

  const handlePaymentClick = async () => {
    if (userId && selectedCard && (paymentSelected || coPaymentSelected)) {
      try {
        setLoading(true);
        const paymentReuseData: ReusePaymentRequest = {
          document_id: userId,
          loan_id: paymentSelected?.loan_id ?? coPaymentSelected?.loan_id ?? '',
          payment_method_id: selectedCard.payment_method_id,
          amount:
            paymentSelected?.amount ?? coPaymentSelected?.certified_debt ?? 0,
          transaction_reason:
            paymentSelected?.transaction_reason ??
            coPaymentSelected?.transaction_reason ??
            TransactionReasonEnum.DEC,
          access_mode: 'FAST_PAY',
        };
        if (flowCO && coPaymentSelected) {
          paymentReuseData.loan_id = coPaymentSelected?.loan_id;
          paymentReuseData.amount = coPaymentSelected.certified_debt ?? 0;
          paymentReuseData.transaction_reason =
            coPaymentSelected.transaction_reason ?? TransactionReasonEnum.DEC;
        }
        if (
          flowCO &&
          ((coPaymentSelected &&
            coPaymentSelected.transaction_reason ===
              TransactionReasonEnum.CPP) ||
            (paymentSelected &&
              paymentSelected.transaction_reason === TransactionReasonEnum.CPP))
        ) {
          if (!loadFromSessionStorage('pepper-payment-plan')) {
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            return;
          }
        }
        const paymentMethods: PaymentMethods = {
          payment_methods: [selectedCard],
        };
        const response = await FinancialService.reusePayment(paymentReuseData);
        const optionalParams: ReusePaymentOptionalParams = {
          transaction_reason:
            flowCO && coPaymentSelected
              ? paymentReuseData.transaction_reason
              : paymentSelected?.transaction_reason,
          excused_amount:
            paymentReuseData.transaction_reason !== TransactionReasonEnum.DEC &&
            paymentReuseData.transaction_reason !== TransactionReasonEnum.CPP
              ? amountExcused
              : 0,
        };
        GAnalyticsService.saveReusePaymentDataLayer(response, optionalParams);
        GAnalyticsService.savePaymentCardType(selectedCard.type);
        GAnalyticsService.savePaymentMethodsDataLayer(paymentMethods);
        if (response.status === 'OK') {
          GAnalyticsService.sendContinuePayment(
            initTime,
            GTMFlowSteps.TYPES_PAYMENTS,
            {
              payment_method: PaymentMethod.EXPRESS,
              payment_transaction_reason: response.transaction_type,
              payment_iin_number: selectedCard.iin_number,
              payment_card_brand: selectedCard.type,
              payment_third_used: '',
            },
          );
          GAnalyticsService.sendPurchase({
            currency: 'EUR',
            transaction_id: response.loan_id,
            value: response.amount,
            items: [
              {
                itemId: `payment-${response.payment_method_id}`,
                itemName: 'Payment-Landing',
              },
            ],
          });
          InsightService.logTrace('Payment Click Success', [
            { PaymentMethod: response.payment_method_id },
            { amount: response.amount.toString() },
            { loan_id: response.loan_id },
            {
              transaction_reason: paymentReuseData.transaction_reason,
            },
            { type: response.transaction_type },
            { route: ROUTES_PATH.TYPES_PAYMENTS },
          ]);
          if (advanceFee) {
            sessionStorage.setItem('advance-fee-OK', 'true');
          }

          navigate(ROUTES_PATH.SUCCESS);
          // Se guarda el pago realizado en el local storage
          newPendingPayment(response);
        } else {
          // Error por ko
          handleErrorPaymentClick();
        }
      } catch (error) {
        // Error por catch
        handleErrorPaymentClick();
      }
    } else {
      setCardList([]);
    }
  };

  const handleErrorPaymentClick = () => {
    const newCardList = cardList.filter((e) => e !== selectedCard);
    setCardList(newCardList);
    setLoading(false);
    changePaymentError(methodSelected as PaymentMethod);
    InsightService.logTrace('Payment Click Error - Payments', [
      { route: ROUTES_PATH.TYPES_PAYMENTS },
      { paymentSelected: JSON.stringify(paymentSelected) },
    ]);
  };

  const getPaymentCards = async () => {
    if (userId) {
      if (cardsResult) {
        setCardList(cardsResult.payment_methods);
        setLoading(false);
      } else {
        try {
          const response = await FinancialService.getPaymentCards(userId);
          setCardList(response.payment_methods);
          GAnalyticsService.savePaymentMethodsDataLayer(response);
        } catch (error) {
          navigate(ROUTES_PATH.UNKNOWN_ERROR);
        } finally {
          setLoading(false);
        }
      }
    } else {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const loadingHandle = (e: boolean) => {
    if (methodSelected === PaymentMethod.APPLE) {
      setLoading(true);
    }
    savePaymentMethodAnalytics();
  };

  const btnBackDebtType = () => {
    GAnalyticsService.sendBackDebtType(initTime);
    deletePaymentSelected();
    if (flowCO) {
      deleteCoPaymentSelected();
      if (loadFromSessionStorage('pepper-payment-plan')) {
        sessionStorage.removeItem('pepper-payment-plan');
        sessionStorage.removeItem('pepper-payment-plan-data');
      }
      if (cardsResult && cardsResult.payment_methods.length > 0) {
        setCardList(cardsResult.payment_methods);
      }
      navigate(ROUTES_PATH.ENTRY_CO);
    } else {
      navigate(ROUTES_PATH.ENTRY);
    }
  };

  const appleOrGoogleSelected = () => {
    if (methodSelected === PaymentMethod.GOOGLE) {
      return { show: true, payment: PaymentTypesEnum.GOOGLE };
    } else if (methodSelected === PaymentMethod.APPLE) {
      return { show: true, payment: PaymentTypesEnum.APPLE };
    } else {
      return { show: false, payment: PaymentTypesEnum.GOOGLE };
    }
  };

  const reusePaymentMethodCreated = async (cardCreated: PaymentCard) => {
    if (userId && (paymentSelected || coPaymentSelected)) {
      try {
        const paymentReuseData: ReusePaymentRequest = {
          document_id: userId,
          loan_id: paymentSelected?.loan_id ?? coPaymentSelected?.loan_id ?? '',
          payment_method_id: cardCreated.payment_method_id,
          amount:
            paymentSelected?.amount ?? coPaymentSelected?.certified_debt ?? 0,
          transaction_reason:
            paymentSelected?.transaction_reason ??
            coPaymentSelected?.transaction_reason ??
            TransactionReasonEnum.DEC,
          access_mode: 'FAST_PAY',
        };
        if (flowCO && coPaymentSelected) {
          paymentReuseData.transaction_reason =
            coPaymentSelected?.transaction_reason ?? TransactionReasonEnum.DET;
          paymentReuseData.amount = coPaymentSelected.certified_debt!;
          paymentReuseData.loan_id = coPaymentSelected.loan_id;
        }
        if (
          flowCO &&
          ((coPaymentSelected &&
            coPaymentSelected.transaction_reason ===
              TransactionReasonEnum.CPP) ||
            (paymentSelected &&
              paymentSelected.transaction_reason === TransactionReasonEnum.CPP))
        ) {
          if (!loadFromSessionStorage('pepper-payment-plan')) {
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            return;
          }
        }
        const response = await FinancialService.reusePayment(paymentReuseData);
        const optionalParams: ReusePaymentOptionalParams = {
          transaction_reason:
            flowCO && coPaymentSelected
              ? paymentReuseData.transaction_reason
              : paymentSelected?.transaction_reason,
          excused_amount:
            paymentReuseData.transaction_reason !== TransactionReasonEnum.DEC &&
            paymentReuseData.transaction_reason !== TransactionReasonEnum.CPP
              ? amountExcused
              : 0,
        };
        GAnalyticsService.saveReusePaymentDataLayer(response, optionalParams);
        if (response.status === 'OK') {
          GAnalyticsService.sendContinuePayment(
            initTime,
            GTMFlowSteps.TYPES_PAYMENTS,
            {
              payment_method: PaymentMethod.GOOGLE,
              payment_transaction_reason: response.transaction_type,
              payment_iin_number: '',
              payment_card_brand: '',
              payment_third_used: '',
            },
          );
          GAnalyticsService.sendPurchase({
            currency: 'EUR',
            transaction_id: response.loan_id,
            value: response.amount,
            items: [
              {
                itemId: `payment-${response.payment_method_id}`,
                itemName: 'Payment-Landing',
              },
            ],
          });
          if (advanceFee) {
            sessionStorage.setItem('advance-fee-OK', 'true');
          }
          navigate(ROUTES_PATH.SUCCESS);
          // Se guarda el pago realizado en el local storage
          newPendingPayment(response);
        } else {
          setShowCardsError(true);
          navigate(ROUTES_PATH.UNKNOWN_ERROR);
        }
      } catch (error) {
        setShowCardsError(true);
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    } else {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const getPaymentMethods = async () => {
    if (userId) {
      try {
        const response = await FinancialService.getPaymentCards(userId);
        reusePaymentMethodCreated(response.payment_methods[0]);
        GAnalyticsService.savePaymentMethodsDataLayer(response);
      } catch (error) {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    } else {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  // Método que permite cambiar las opciones de pago según el tipo de pago con error registrado
  const changePaymentError = (paymentMethod: PaymentMethod) => {
    setShowCardsError(true);
    setMethodSelected(null);
    if (!sessionStorage.getItem('pepper-payment-method-error')) {
      savePaymentMethodError(paymentMethod);
    }
    const newRetryOrder = handlePaymentTypesOrder(paymentMethod);
    setRetryOrder(newRetryOrder);
    GAnalyticsService.sendPaymentError(initTime, paymentMethod);
  };

  const getRemainingDebt = () => {
    let remainingDebt = 0.0;
    if (debtResult && currentLoan) {
      if (
        coPaymentSelected &&
        coPaymentSelected.transaction_reason === TransactionReasonEnum.DEC &&
        currentLoan?.certified_debt
      ) {
        // Cálculo de la deuda cuando es amortizado manual con varias operaciones CO
        remainingDebt =
          currentLoan.certified_debt - coPaymentSelected.certified_debt!;
      } else if (
        paymentSelected &&
        paymentSelected.transaction_reason === TransactionReasonEnum.DEC
      ) {
        //  Cálculo de la deuda cuando es amortizado manual con una sola operación CO
        remainingDebt = coTotalAmount - paymentSelected.amount!;
      }

      if (remainingDebt < 0) {
        remainingDebt = 0;
      }
    }

    return pricesHelper(remainingDebt ?? 0);
  };

  const getCoDebtTitle = () => {
    let transactionType: TransactionReasonEnum | undefined;

    if (coPaymentSelected) {
      transactionType = coPaymentSelected.transaction_reason;
    } else if (paymentSelected) {
      transactionType = paymentSelected.transaction_reason;
    }
    switch (transactionType) {
      case TransactionReasonEnum.DEC:
        return (
          <TextBold fontSize={18} lineHeight={24}>
            {TransactionReasonTexts[TransactionReasonEnum.DEC]}
          </TextBold>
        );
      case TransactionReasonEnum.CPP:
        return (
          <TextBold fontSize={18} lineHeight={24}>
            {TransactionReasonTexts[TransactionReasonEnum.CPP]}
          </TextBold>
        );
      default:
        return (
          <TextBold fontSize={18} lineHeight={24}>
            Pagar todo
          </TextBold>
        );
    }
  };

  const calculateAmounts = (debtInfo: DebtResponse) => {
    let excusedAmount;
    if (flowCO) {
      if (coPaymentSelected) {
        const promotion = debtResult?.promotions.find(
          (e) => e.loan_id === coPaymentSelected.loan_id,
        );
        excusedAmount = promotion?.amount_excused ?? 0;
      } else {
        excusedAmount =
          debtInfo.promotions.length > 0
            ? calculateTotalExcusedAmount(debtInfo)
            : 0;
      }
      setAmountExcused(excusedAmount);
      setCoTotalAmount(getDebtAmount(debtInfo) ?? 0);
    } else if (paymentSelected) {
      excusedAmount =
        paymentSelected.amount_excused ??
        debtInfo.promotions.find((e) => e.loan_id === paymentSelected.loan_id)
          ?.amount_excused ??
        0;
      setAmountExcused(excusedAmount);
    }
  };

  const handleWalletSuccess = () => {
    setLoading(true);
    InsightService.logTrace('WALLETSuccess', [
      { paymentMethodSelected: `WALLET ${methodSelected}` },
      { success: true },
    ]);
    getPaymentMethods();
    savePaymentMethodAnalytics();
  };

  useEffect(() => {
    if (methodSelected) {
      if (paymentMethod !== methodSelected) {
        sessionStorage.setItem('pepper-payment-method', methodSelected);
      }
    }
    if (methodSelected === PaymentMethod.BIZUM && !paymentBizum) {
      createPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [methodSelected]);

  useEffect(() => {
    if (advanceFeeOK) {
      navigate(ROUTES_PATH.SUCCESS);
    }

    getPaymentCards();
    if (debtResult) {
      let loan;
      if (coPaymentSelected) {
        loan = debtResult.loans?.find(
          (e) => e.loan_id === coPaymentSelected?.loan_id,
        );
        setCurrentLoan(loan);
      } else if (paymentSelected) {
        loan = debtResult.loans?.find(
          (e) => e.loan_id === paymentSelected?.loan_id,
        );
        setCurrentLoan(loan);
      }

      if (
        debtResult.loans.length === 1 &&
        debtResult.loans[0].installments.length === 1
      ) {
        setIsOneQuotaDebt(true);
      }
      setInitTime(dayjs());
      calculateAmounts(debtResult);
    }

    if (paymentMethodError || sofortPaymentKo) {
      if (paymentMethodError === PaymentMethod.EXPRESS) {
        handleErrorPaymentClick();
      }
      setMethodSelected(null);
      sessionStorage.removeItem('pepper-payment-method');
      if (sofortPaymentKo) {
        paymentMethodError = PaymentMethod.BANK_ACCOUNT;
        localStorage.removeItem('sofortPayment');
      }
      changePaymentError(paymentMethodError as PaymentMethod);
    } else {
      setShowCardsError(false);
    }

    const planData = loadFromSessionStorage('pepper-payment-plan');
    if (paymentPlanData || planData) {
      setCreatingPaymentPlan(true);
    }

    const handleFromApp = (e: any) => {
      handleBizumError();
    };
    window.addEventListener('fromApp', handleFromApp);

    return () => {
      window.removeEventListener('fromApp', handleFromApp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!loading && (
        <PaymentWrapper id="payment-select-page">
          <PaymentOverlay
            open={modalOpened}
            onClick={() => setmodalOpened(false)}
            id="other-payment-open-btn"
          />

          <PaymentView id="payment-view">
            <ContainerBackgroundMenu id="container-background-menu">
              {showCardsError && <ErrorMessage />}
              <PaymentHeader id="payment-header">
                <AmountTitle id="payment-amount-title">
                  <TitleSection id="payment-section-title">
                    <MoneyWrapper id="header-money-wrapper">
                      <IconMoney />
                    </MoneyWrapper>
                    {paymentSelected && !flowCO && (
                      <TextBold fontSize={18} lineHeight={24}>
                        {paymentSelected.transaction_reason ===
                          TransactionReasonEnum.DE1 && isOneQuotaDebt
                          ? 'Deuda Pendiente'
                          : TransactionReasonTexts[
                              paymentSelected.transaction_reason
                            ]}
                      </TextBold>
                    )}
                    {flowCO && getCoDebtTitle()}
                  </TitleSection>
                </AmountTitle>
                <PaymentSection id="payment-section">
                  <AmountColumn id="payment-amount-column">
                    <PaymentInformation id="payment-information">
                      {!paymentPlanData && (
                        <TextRegular
                          fontSize={14}
                          color="gray6"
                          lineHeight={20}
                        >
                          Importe a pagar
                        </TextRegular>
                      )}

                      {flowCO && creatingPaymentPlan && paymentPlanData && (
                        <TextRegular
                          fontSize={14}
                          color="gray6"
                          lineHeight={20}
                        >
                          Hoy vas a pagar
                        </TextRegular>
                      )}
                    </PaymentInformation>
                    <PaymentInformationRow id="payment-amount-info">
                      <TextBold fontSize={18} lineHeight={24}>
                        {paymentSelected &&
                          !coPaymentSelected &&
                          pricesHelper(paymentSelected.amount)}
                        {flowCO &&
                          coPaymentSelected &&
                          coPaymentSelected.certified_debt &&
                          pricesHelper(coPaymentSelected.certified_debt)}
                        <TextRegular fontSize={12}> €</TextRegular>
                      </TextBold>
                      {((paymentSelected &&
                        paymentSelected.amount_excused !== 0 &&
                        !paymentPlanData &&
                        paymentSelected?.transaction_reason !==
                          TransactionReasonEnum.DEC &&
                        paymentSelected?.transaction_reason !==
                          TransactionReasonEnum.CPP) ||
                        (coPaymentSelected &&
                          amountExcused > 0 &&
                          !paymentPlanData &&
                          coPaymentSelected?.transaction_reason !==
                            TransactionReasonEnum.DEC &&
                          coPaymentSelected?.transaction_reason !==
                            TransactionReasonEnum.CPP)) && (
                        <InfoCardMiniSpan id="payment-green-info-text-1">
                          <CardLabel fontSize={14} lineHeight={16}>
                            Ahorras{' '}
                            {paymentSelected &&
                              !coPaymentSelected &&
                              pricesHelper(paymentSelected.amount_excused)}
                            {flowCO &&
                              coPaymentSelected &&
                              amountExcused > 0 &&
                              pricesHelper(amountExcused)}
                            €
                          </CardLabel>
                        </InfoCardMiniSpan>
                      )}
                      {creatingPaymentPlan &&
                      paymentPlanData &&
                      TransactionReasonEnum.CPP ? (
                        <InfoCardPaymentPlan
                          id="co-payment-green-info-text-2"
                          backgroundColor={colors.yellow10}
                        >
                          <PaymentPlanTextMedium
                            fontSize={14}
                            lineHeight={16}
                            id="payment-plan-text-info"
                          >
                            + {paymentPlanData.term - 1}{' '}
                            {paymentPlanData.term - 1 === 1
                              ? 'cuota de'
                              : 'cuotas de'}{' '}
                          </PaymentPlanTextMedium>
                          <PaymentPlanTextBold
                            fontSize={14}
                            lineHeight={16}
                            id="payment-plan-amount-info"
                          >
                            {paymentPlanData &&
                              pricesHelper(paymentPlanData.installment)}{' '}
                            €
                          </PaymentPlanTextBold>
                        </InfoCardPaymentPlan>
                      ) : (
                        (paymentSelected?.transaction_reason ===
                          TransactionReasonEnum.DEC ||
                          coPaymentSelected?.transaction_reason ===
                            TransactionReasonEnum.DEC) && (
                          <InfoCardMiniSpan id="co-payment-green-info-text-3">
                            <CardLabel fontSize={14} lineHeight={16}>
                              Deuda restante {getRemainingDebt()}€
                            </CardLabel>
                          </InfoCardMiniSpan>
                        )
                      )}
                    </PaymentInformationRow>
                  </AmountColumn>
                </PaymentSection>
                {flowCO && creatingPaymentPlan && paymentPlanData && (
                  <TextRegular fontSize={14} color="gray6" lineHeight={20}>
                    *El giro del resto de cuotas se realizará el día{' '}
                    {paymentPlanData.payment_day} de cada mes.
                  </TextRegular>
                )}
              </PaymentHeader>
            </ContainerBackgroundMenu>
            <PaymentSelectText
              fontSize={16}
              color="gray0"
              lineHeight={22}
              id="payment-select-text"
            >
              Selecciona un método de pago
            </PaymentSelectText>
            <CardsList id="payments-cards-list" $marginBottom={embedded}>
              <PaymentTypes
                method={(data) => {
                  setMethodSelected(data);
                  // console.log('Método de pago seleccionado: ', data);
                  GAnalyticsService.sendChangePaymentMethod();
                }}
                cardList={cardList}
                cardSelected={(card) => setSelectedCard(card)}
                otherOptionsClick={() => {
                  setmodalOpened(true);
                  GAnalyticsService.sendOtherOptions();
                }}
                appleAvailable={isAppleAvailable && !embedded}
                googleAvailable={isGoogleAvailable}
                bizumAvailable={true}
                resetSelection={resetBizum}
                retryOrder={retryOrder || defaultRetryOrder}
                activeError={showCardsError}
              />
            </CardsList>
            <ButtonSection id="payment-button-section">
              {!advanceFee && (
                <ButtonsWrapperPayment
                  wrapperPadding="0 10px 0 0"
                  id="payment-back-btn-wrapper"
                >
                  <Button
                    page={sessionStorage.getItem('flow') === 'co' ? '3' : '2'}
                    color={red4}
                    border={'2px'}
                    borderColor={red4}
                    backgroundColor={white}
                    id="payment-back-btn"
                    click={() => btnBackDebtType()}
                  >
                    <TextBold fontSize={18} color={red4} lineHeight={20}>
                      Vuelve al inicio
                    </TextBold>
                  </Button>
                </ButtonsWrapperPayment>
              )}
              {methodSelected === PaymentMethod.BIZUM &&
                paymentBizum &&
                !appViewMode && (
                  <ButtonsWrapperBizum
                    wrapperPadding="0 0 0 10px"
                    id="payment-next-btn-bizum-wrapper"
                  >
                    <Bizum
                      url={paymentBizum.third_party_url}
                      successEnd={() => {
                        handleSuccessEnd();
                        // navigate(ROUTES_PATH.SUCCESS);
                      }}
                      error={() => {
                        handleBizumError();
                      }}
                      // onClick={() => analyticsMethod()}
                      btnText={'Completa el pago'}
                      // btnColor=''
                      btnBackgroundColor={red4}
                      btnBorderRadius="24px"
                      btnFontSize="18px"
                      btnFontWeight="700"
                      btnHeight="50px"
                      // btnWidth=''
                    />
                  </ButtonsWrapperBizum>
                )}
              {methodSelected === PaymentMethod.BIZUM &&
                paymentBizum &&
                appViewMode && (
                  <Button
                    click={() => handleAppBizumPayment()}
                    color={white}
                    borderColor={red4}
                    backgroundColor={red4}
                    fontWeight={textBold}
                    disabled={!methodSelected || loadingBizum}
                    id="payment-next-btn payment-main-btn"
                  >
                    <span>Completa el pago bizum</span>
                  </Button>
                )}
              {((methodSelected === PaymentMethod.BIZUM && loadingBizum) ||
                (methodSelected !== PaymentMethod.APPLE &&
                  methodSelected !== PaymentMethod.GOOGLE &&
                  methodSelected !== PaymentMethod.BIZUM)) && (
                <ButtonsWrapperPayment
                  wrapperPadding="0 0 0 10px"
                  id="payment-next-btn-wrapper"
                >
                  <Button
                    click={() => openPayment()}
                    color={white}
                    borderColor={red4}
                    backgroundColor={red4}
                    fontWeight={textBold}
                    disabled={!methodSelected || loadingBizum}
                    id="payment-next-btn payment-main-btn"
                  >
                    <span>Completa el pago</span>
                  </Button>
                </ButtonsWrapperPayment>
              )}
              <PayButtonWrapper
                show={
                  methodSelected === PaymentMethod.APPLE ||
                  methodSelected === PaymentMethod.GOOGLE
                }
                id="payment-next-btn-app-wrapper"
              >
                <PaymentHandle
                  publicKey={process.env.REACT_APP_MC2P_PUBLIC_KEY ?? ''}
                  token={TokenService.getToken()!}
                  isLoading={loadingHandle}
                  isAppleAvailable={(status: boolean) => {
                    GAnalyticsService.saveAppleDeviceDataLayer(status);
                    if (appViewMode) {
                      setIsAppleAvailable(false);
                    } else {
                      setIsAppleAvailable(status);
                    }
                  }}
                  isGoogleAvailable={(status: boolean) => {
                    GAnalyticsService.saveGoogleDeviceDataLayer(status);
                    if (appViewMode) {
                      setIsGoogleAvailable(false);
                    } else {
                      setIsGoogleAvailable(status);
                    }
                  }}
                  showGoogleOrAppleBtn={appleOrGoogleSelected()}
                  handleError={(e: any) => {
                    setLoading(false);
                    changePaymentError(methodSelected as PaymentMethod);
                    setMethodSelected(null);
                  }}
                  environment={process.env.REACT_APP_ENV!}
                  handleSuccess={handleWalletSuccess}
                  paymentSelected={{
                    loan_id:
                      paymentSelected?.loan_id! || coPaymentSelected?.loan_id,
                    transaction_reason:
                      (paymentSelected?.transaction_reason! as PaymentTransactionReasonEnum) ||
                      coPaymentSelected?.transaction_reason,
                  }}
                  userDocument={userResult?.document_id!}
                />
              </PayButtonWrapper>
            </ButtonSection>
            {modalOpened && (
              <PaymentModal
                close={() => {
                  setmodalOpened(false);
                }}
                loan={currentLoan}
                amount={paymentSelected && pricesHelper(paymentSelected.amount)}
              />
            )}
          </PaymentView>
        </PaymentWrapper>
      )}
      {loading && <Transition />}
    </>
  );
};

export default Payment;
